import { CatalogDependenciesObject } from './catalog-dependencies-object.model';
import { CatalogCharacteristicObject } from './catalog-characteristic-object.model';

export class CatalogInfoObject {
    _characteristics: Array<CatalogCharacteristicObject>;
    _dependencies: CatalogDependenciesObject;

    constructor(characteristics: Array<CatalogCharacteristicObject>, dependencies: CatalogDependenciesObject) {
        this._characteristics = characteristics;
        this._dependencies = dependencies;
    }

    static create(): CatalogInfoObject {
        return new CatalogInfoObject(new Array<CatalogCharacteristicObject>(), CatalogDependenciesObject.create());
    }

    public get characteristics(): Array<CatalogCharacteristicObject> {

        if (this._characteristics === undefined) {
            this._characteristics = new Array<CatalogCharacteristicObject>();
        }
        return this._characteristics;
    }

    public get dependencies(): CatalogDependenciesObject {
        return this._dependencies;
    }    

}